import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { Store } from '../../../store/player/types';

export const persistSkipPausesState = (store: Store): void => {
  const { skipPauses, setLastTickTime } = store.getState();

  setLastTickTime(null); // we want to ignore first tick when we toggle skip pauses.
  LocalStorage.set('playbacksSkipPauses', skipPauses);
};
